import { Login } from 'views/Auth';

const authRoute = {
  login: {
    path: '/login',
    url: '/auth/login',
    component: Login,
  },
};

export default authRoute;
